export const careersMessageModalSx = {
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  backdrop: {
    backgroundColor: "transparent"
  },
  box: {
    position: "relative",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    px: 3,
    py: 6,
    pb: 2,
    gap: 4,
    borderRadius: 2,
  },
  closeIconBox: {
    position: "absolute",
    top: 8,
    right: 8,
    cursor: "pointer",
  },
  educatorCloseButton: {
    backgroundColor: "white",
    color: "black",
    "&:hover": { backgroundColor: "#f0f0f0" }
  }
};
